import { render, staticRenderFns } from "./AssessmentInstructions.vue?vue&type=template&id=47ea0c6c&"
import script from "./AssessmentInstructions.vue?vue&type=script&lang=js&"
export * from "./AssessmentInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports